/**
 * Notification Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificationAddressDto { 
    addressId?: number;
    value?: string;
    description?: string;
    type?: NotificationAddressDto.TypeEnum;
}
export namespace NotificationAddressDto {
    export const TypeEnum = {
        Email: 'EMAIL',
        FirebaseToken: 'FIREBASE_TOKEN',
        Sms: 'SMS',
        Telegram: 'TELEGRAM',
        Whatsapp: 'WHATSAPP',
        Webhook: 'WEBHOOK'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


